import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import LockTwoToneIcon from '@mui/icons-material/LockTwoTone';
import { useState, useEffect } from "react";


export const AccessDenied: React.FC = ( ) => {
    
    const [ shouldDisplay, setShouldDisplay ] = useState< boolean >( false );

    useEffect(() => { 

        const timer = setTimeout( ( ) => { 
     
            setShouldDisplay( true );
     
        }, 500); 
     
        return () => { 
     
           clearTimeout( timer ); 
     
        };
     
     }, [ ]);
    
    return (

        <>
        {
            shouldDisplay
                &&
            <Grid 
                container
                spacing={0}
                direction="row"
                alignItems="center"
                justifyContent="center"
                style={{ minHeight: '100vh' }}
                gap={2}
            >
                
                <Card>
                    <CardContent>
                        <Typography align="center" sx={{color:'rgb(230, 84, 0)', fontWeight:'bold', fontSize:'50px'}}>
                            BHP
                        </Typography>
                        <Typography>
                            You do not have permissions to access this application
                        </Typography>
                        <Box display="flex" justifyContent="center">
                            <LockTwoToneIcon sx={{ color: '#e65400', fontSize: '100px' }} />
                        </Box>
                    </CardContent>
                </Card>

            </Grid>
        }
        </>

    );
};